import { createAction } from "@reduxjs/toolkit";
import { Beach, PaginationOptions, Seat } from "../../interfaces";
import * as BeachActionTypes from "./types";

export const loadAllBeach = createAction<Partial<PaginationOptions>>(
  BeachActionTypes.fetch_paginated_beaches_saga
);
export const loadBeachById = createAction<string>(
  BeachActionTypes.fetch_beach_by_id_saga
);
export const createBeach = createAction<Omit<Beach, "uid">>(
  BeachActionTypes.create_new_beach_saga
);
export const updateBeach = createAction<Beach>(
  BeachActionTypes.update_beach_saga
);
export const deleteBeachById = createAction<string>(
  BeachActionTypes.delete_beach_saga
);
export const createCities = createAction<Omit<Beach, "uid">>(
  BeachActionTypes.create_new_beach_saga
);
export const createSeat = createAction<{
  seat: Omit<Seat, "id">;
  beachId: string;
}>(BeachActionTypes.create_seat_saga);

export const updateSeat = createAction<{
  seat: Seat;
  beachId: string;
}>(BeachActionTypes.update_seat_saga);

export const deleteSeat = createAction<{ seatId: string; beachId: string }>(
  BeachActionTypes.delete_seat_saga
);
